import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomers, StateStatus } from '@guryou/redux';

import { resetState } from '../actions';
import { CUSTOMERS_GET_MANY } from '../types';

const useClients = (stateSelector, noWlakinClients = false, rs = true, notArchived = null, active = null, isApproved = null) => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(stateSelector);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getCustomers(notArchived, active, isApproved));
    }
  }, [active, dispatch, isApproved, notArchived, status]);

  useEffect(() => {
    return () => rs && dispatch(resetState(CUSTOMERS_GET_MANY));
  }, [dispatch, rs]);

  if (noWlakinClients) {
    return { data: (data || []).filter(x => x?.id && (x?.id !== null || x?.id !== undefined)) || [], status, version, entity };
  }
  return { data: data || [], status, version, entity };
};

export default useClients;
